"use strict";


import React from 'react';


export default function GaijinToolPanel({type, caption, children, additional})  {
    return  (
      <div>
        <div className={`panel panel-${type || "default"} GaijinToolPanel`}>
          {!!caption &&
            <div className="panel-heading">
              <b>Gaijin Market:</b> {caption}
            </div>}
          <div className="panel-body">
            <div className="text-center logo">
              <img src="images/gaijin_logo.png" />
            </div>

            {children}

          </div>
        </div>
        {additional}
      </div>
      );
}

